module.exports = __webpack_public_path__ + "img/goods-pic-place.23c73792.png";